export function clearDomainCookies() {
    const hostname = window.location.hostname
    const domainParts = hostname.split('.')

    const domains = []
    if (domainParts.length > 2) {
        const parentDomain = domainParts.slice(-2).join('.')
        domains.push(hostname, `.${parentDomain}`)
    } else {
        domains.push(hostname)
    }

    const cookies = document.cookie.split(';')

    for (const cookie of cookies) {
        const [rawName] = cookie.split('=')
        const name = rawName.trim()

        for (const domain of domains) {
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${domain}; path=/;`
        }
    }
}

export function clearAllFromCurrentDomain() {
    clearDomainCookies()
    localStorage.removeItem('trySSO');
    console.log('Очищено все что есть в текущем домене')
}

export function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (let cookie of cookies) {
        const [key, value] = cookie.split('=');
        if (key === name) {
            return decodeURIComponent(value);
        }
    }
    return null; // Если куки с таким именем не найдено
}

export function deleteAllCookies() {
    // Получаем все куки
    const cookies = document.cookie.split(";");

    // Удаляем каждую куку
    for (let cookie of cookies) {
        // Получаем имя куки
        const cookieName = cookie.split("=")[0].trim();

        // Устанавливаем её с истёкшим сроком действия
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
}

export const setCookie = (key, value, days) => {
    const date = new Date();
    const domainName = window.location.hostname;
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // days → миллисекунды
    document.cookie = `${key}=${value}; expires=${date.toUTCString()}; path=/; secure; domain=.${domainName}`;
};
